import { Box, Tiles } from 'braid-design-system';
import { useEffect, useState } from 'react';

import { NewProfileVisibilityCard } from './NewProfileVisibilityCard';

export interface ProfileVisibilityConfigType {
  type: string;
  isRecommended: boolean;
  canViewResume: boolean;
  isProfileHidden: boolean;
}

export interface NewProfileVisibilitySettingType {
  title: 'Employers Can:' | 'Anyone Can:';
  findProfile?: boolean;
  seeBasicProfile?: boolean;
  seeProfile?: boolean;
  contactOpportunities?: boolean;
  viewResume?: boolean;
  verifiedInfo?: boolean;
}
export interface NewProfileVisibilityConfigType {
  type: 'Public' | 'Standard' | 'Limited' | 'Hidden';
  description:
    | 'Maximum visibility'
    | 'Partial visibility'
    | 'Minimum visibility'
    | 'No visibility';
  isRecommended: boolean;
  isProfileHidden: boolean;
  settings: NewProfileVisibilitySettingType[] | undefined;
}

const newProfileVisibilitySettingConfig: NewProfileVisibilityConfigType[] = [
  {
    type: 'Public',
    description: 'Maximum visibility',
    isRecommended: true,
    isProfileHidden: false,
    settings: [
      {
        title: 'Anyone Can:',
        findProfile: true,
        seeBasicProfile: true,
      },
      {
        title: 'Employers Can:',
        seeProfile: true,
        contactOpportunities: true,
        verifiedInfo: true,
        viewResume: true,
      },
    ],
  },
  {
    type: 'Standard',
    description: 'Partial visibility',
    isRecommended: false,
    isProfileHidden: false,
    settings: [
      {
        title: 'Employers Can:',
        seeProfile: true,
        contactOpportunities: true,
        verifiedInfo: true,
        viewResume: true,
      },
    ],
  },
  {
    type: 'Limited',
    description: 'Minimum visibility',
    isRecommended: false,
    isProfileHidden: false,
    settings: [
      {
        title: 'Employers Can:',
        seeProfile: true,
        contactOpportunities: true,
        verifiedInfo: true,
        viewResume: false,
      },
    ],
  },
  {
    type: 'Hidden',
    description: 'No visibility',
    isRecommended: false,
    isProfileHidden: true,
    settings: undefined,
  },
];

export const ProfileVisibilityCardGroup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => setIsVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Tiles
      columns={{ mobile: 1, tablet: 4 }}
      space={{ mobile: 'medium', tablet: 'xsmall' }}
    >
      {newProfileVisibilitySettingConfig.map((profileConfig, index) => (
        <Box
          key={profileConfig.type}
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: `opacity 0.6s ease-out ${
              index * 0.1
            }s, transform 0.6s ease-out ${index * 0.1}s`,
          }}
        >
          <NewProfileVisibilityCard profileConfig={profileConfig} />
        </Box>
      ))}
    </Tiles>
  );
};
